import React, { useEffect } from "react";
import { Checkbox, FormControlLabel, Grid } from "@material-ui/core";
import { Controller, useWatch } from "react-hook-form";
import { RegulatorsToNotifyModel } from "../../domain/SocItem";
import { Error } from "../common/Error";
import { SectionProps } from "./SectionProps";
import { useLocation } from "react-router-dom";

export const RegulatorsToNotify: React.FC<SectionProps<RegulatorsToNotifyModel>> = ({
  control,
  disabled,
  formState: { isSubmitted },
  errors,
  registerCustomError,
}) => {
  const {
    regulatorsToNotifyCcea,
    regulatorsToNotifyOfqual,
    regulatorsToNotifyQw,
  } = useWatch<RegulatorsToNotifyModel>({
    control,
    name: [
      "regulatorsToNotifyCcea",
      "regulatorsToNotifyOfqual",
      "regulatorsToNotifyQw",
    ],
  });

  const year = useLocation().pathname.split('/')[2];

  const isOptionSelected = regulatorsToNotifyCcea || regulatorsToNotifyOfqual || (regulatorsToNotifyQw && year === "2024");
  const isCheckboxRequired = isSubmitted && !isOptionSelected;

  useEffect(() => {
    registerCustomError("regulatorsToNotifyOfqual", isCheckboxRequired);
  }, [registerCustomError, isCheckboxRequired]);

  return (
    <Grid container spacing={3} direction="row">
      <Controller
        control={control}
        name="regulatorsToNotifyOfqual"
        rules={{ required: !isOptionSelected }}
        render={(props) => (
          <Grid item xs={12}>
            <Controller
              control={control}
              name="regulatorsToNotifyOfqual"
              render={(props) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={(e) => {
                        props.onChange(e.target.checked);
                      }}
                      checked={props.value}
                      disabled={disabled}
                      data-test="regulatorsToNotifyOfqual"
                    />
                  }
                  label="Ofqual"
                />
              )}
            />
            <Controller
              control={control}
              name="regulatorsToNotifyCcea"
              render={(props) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={(e) => {
                        props.onChange(e.target.checked);
                      }}
                      checked={props.value}
                      disabled={disabled}
                      data-test="regulatorsToNotifyCcea"
                    />
                  }
                  label="CCEA Regulation"
                />
              )}
            />
            {year === "2024" &&
              <Controller
                control={control}
                name="regulatorsToNotifyQw"
                render={(props) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={(e) => {
                          props.onChange(e.target.checked);
                        }}
                        checked={props.value}
                        disabled={disabled}
                        data-test="regulatorsToNotifyQw"
                      />
                    }
                    label="Qualifications Wales"
                  />
                )}
              />
            }
          </Grid>
        )}
      />
      <br />
      {isCheckboxRequired && (
        <Error data-test="regulators-affected-error">
          Please select at least one Regulator
        </Error>
      )}
    </Grid>
  );
};
